import React, { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/api";

const CampaignAssetsContext = createContext(null);

export function CampaignAssetsProvider({ children }) {
  const [batchesByProject, setBatchesByProject] = useState({});

  const refreshBatches = useCallback(async (projectId) => {
    try {
      const { data } = await api.get(`/projects/${projectId}/campaign-asset-batches`);
      setBatchesByProject((prev) => ({ ...prev, [projectId]: data }));
      return data;
    } catch {
      return [];
    }
  }, []);

  const createBatch = useCallback(async (projectId, payload) => {
    const { data } = await api.post(`/projects/${projectId}/campaign-asset-batches`, payload);
    await refreshBatches(projectId);
    return data;
  }, [refreshBatches]);

  const deleteBatch = useCallback(async (projectId, batchId) => {
    await api.delete(`/campaign-asset-batches/${batchId}`);
    await refreshBatches(projectId);
  }, [refreshBatches]);

  return (
    <CampaignAssetsContext.Provider value={{ batchesByProject, refreshBatches, createBatch, deleteBatch }}>
      {children}
    </CampaignAssetsContext.Provider>
  );
}

export function useCampaignAssets() {
  const ctx = useContext(CampaignAssetsContext);
  if (!ctx) throw new Error("useCampaignAssets must be used within CampaignAssetsProvider");
  return ctx;
}
